import * as React from 'react';
import './navbar-item.scss';
import { RootState } from 'core/redux/store';
import { connect, ConnectedProps, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { setMenuItem, setSidebar } from 'core/redux/actions';

const mapState = (state: RootState) => ({
    state: state,
});

const connector = connect(mapState);
type PropsFromRedux = ConnectedProps<typeof connector>;

interface Props extends PropsFromRedux {
    id: number;
    title: string;
    icon?: React.ReactNode;
    link?: string;
    className?: string;
    isActive?: boolean;
    onClickHandle?: () => void;
}

const MobileNavigationbarItem: React.FC<Props> = (props) => {
    const dispatch = useDispatch();

    function onSelect() {
        dispatch(setMenuItem(props.id));
        dispatch(setSidebar('close'));
    }

    return (
        <Link
            to={props.link ?? ''}
            onClick={() => {
                onSelect();
            }}
            className={`mobile-navigationbar-item ${
                props.state.menu === props.id ? 'active' : ''
            } ${props.className ?? ''} ${props.isActive ? 'filled' : ''}`}
        >
            <div className="content">
                {props.icon}
                <p className="title">{props.title}</p>
            </div>
        </Link>
    );
};
export default connector(MobileNavigationbarItem);
